import { LineChart as RechartsLineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Dot } from 'recharts';

const LineChart = ({ data, dataKey = "value", xAxisKey = "name" }) => {
  // Calculate dynamic domain based on data
  const values = data.map(item => item[dataKey]);
  const minValue = Math.min(...values);
  const maxValue = Math.max(...values);
  const padding = (maxValue - minValue) * 0.2 || 10; // 20% padding or minimum 10
  const yMin = Math.floor(minValue - padding);
  const yMax = Math.ceil(maxValue + padding);
  
  return (
    <ResponsiveContainer width="100%" height="100%">
      <RechartsLineChart
        data={data}
        margin={{ top: 10, right: 20, left: 10, bottom: 10 }}
      >
        <CartesianGrid 
          strokeDasharray="5 5" 
          horizontal={true}
          vertical={true}
          stroke="#E5E7EB"
          strokeOpacity={0.5}
        />
        <XAxis 
          dataKey={xAxisKey}
          tick={{ fill: '#9CA3AF', fontSize: 12 }}
          axisLine={{ stroke: '#E5E7EB' }}
          tickLine={false}
        />
        <YAxis 
          tick={{ fill: '#9CA3AF', fontSize: 12 }}
          axisLine={{ stroke: '#E5E7EB' }}
          tickLine={false}
          domain={[yMin, yMax]}
        />
        <Line 
          type="monotone" 
          dataKey={dataKey}
          stroke="#6B7280"
          strokeWidth={2}
          dot={<Dot r={5} fill="#3B82F6" />}
        />
      </RechartsLineChart>
    </ResponsiveContainer>
  );
};

export default LineChart;
